import { brand, category } from '@alison/ui';

export type FilterFamilyId = 'breakdown' | 'campaign' | 'creative' | 'targeting';

export type FilterMatchOperator = 'AND' | 'OR';

export interface FilterFamily {
  label: string;
  tone: string;
  matchOperator: FilterMatchOperator;
}

export const FILTER_FAMILIES: Record<FilterFamilyId, FilterFamily> = {
  breakdown: {
    label: 'Performance breakdown axes',
    tone: category.attract.main,
    matchOperator: 'OR',
  },
  campaign: {
    label: 'Campaign & delivery attributes',
    tone: category.direct.main,
    matchOperator: 'AND',
  },
  creative: {
    label: 'Creative & conceptual attributes',
    tone: category.brand.main,
    matchOperator: 'AND',
  },
  targeting: {
    label: 'Audience targeting facets',
    tone: brand.purple,
    matchOperator: 'AND',
  },
};

export const FILTER_FAMILY_ORDER: FilterFamilyId[] = [
  'breakdown',
  'campaign',
  'creative',
  'targeting',
];
